<template>
  <div class="d-inline-block overlay-wrapper" @blur="overlayVisible = false">
    <transition name="fade">
      <div class="invisible-overlay" @click="overlayVisible = false" v-show="overlayVisible"></div>
    </transition>
    <div
      class="overlay-static"
      @focus="overlayVisible = true"
      ref="overlay_static"
      :style="{ 'z-index': staticZIndex }"
    >
      <slot name="overlay-static"></slot>
    </div>
    <transition name="scale-down">
      <div
        class="card bordered overlay"
        v-show="overlayVisible"
        ref="overlay"
        :style="{
          'margin-left': '-' + offset_left + 'px',
          'margin-top': '-' + (staticHeight + offsettop) + 'px',
          'padding-top': staticHeight + 10 + 'px'
        }"
      >
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  props: {
    value: '',
    offsettop: {
      default: 20
    }
  },
  data: function () {
    return {
      staticHeight: 34,
      staticZIndex: 'initial',
      offset_left: 0
    };
  },
  computed: {
    overlayVisible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      }
    }
  },
  watch: {
    value: function () {
      if (this.value) {
        let staticHeight = this.$refs.overlay_static.offsetHeight;
        this.staticHeight = staticHeight;

        _.defer(() => {
          let rect = this.$refs.overlay.getBoundingClientRect();

          if (window.innerWidth < rect.x + rect.width) {
            this.offset_left = rect.x + rect.width - window.innerWidth + 20;
          }
        });

        this.staticZIndex = 999;
      } else {
        setTimeout(() => (this.staticZIndex = 'initial'), 200);
      }
    }
  },
  methods: {},
  mounted() {
    /*
      let staticHeight = this.$refs.overlay_static.offsetHeight

      console.log('staticHeight', staticHeight)
      this.staticHeight = staticHeight */
  }
};
</script>

<style scoped>
.overlay-wrapper {
  position: relative;
}

.overlay {
  position: absolute;
  left: -20px;
  z-index: 99;
  min-width: 150%;
}

.overlay-static {
  position: relative;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.invisible-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  width: 100%;
  height: 100%;
  background-color: rgba(39, 39, 39, .09);
}

.scale-down-enter-active,
.scale-down-leave-active {
  transform-origin: top center;
  transition: transform .2s ease-in, opacity .2s ease-in;
}

.scale-down-enter,
.scale-down-leave-to {
  /* matrix(scaleX(),skewY(),skewX(),scaleY(),translateX(),translateY()) */
  /* transform: scale(1,0.5); */
  transform-origin: top center;
  opacity: 0;
}
</style>
